import { ReportFileType, SavedReportFileDTO } from "src/app/base/models/models.swagger.generated";

export class DownloadLinkUtil {
  public static createInvisibleDownloadLink(savedReportFileDTO: SavedReportFileDTO): HTMLAnchorElement {
    const source = `data:application/octet-stream;base64,${savedReportFileDTO.contentBase64}`;
    const link = document.createElement('a');
    const fileExtension = this.getFileExtension(savedReportFileDTO.fileType);

    // check if the file name contains file extension
    if (savedReportFileDTO.reportName.toUpperCase().endsWith('.' + fileExtension.toUpperCase())) {
      savedReportFileDTO.reportName = savedReportFileDTO.reportName.substring(0, savedReportFileDTO.reportName.length - fileExtension.length - 1);
    }

    link.href = source;
    link.download = `${savedReportFileDTO.reportName}.${fileExtension}`;
    return link;
  }

  private static getFileExtension(fileType: ReportFileType): string {
    return ReportFileType[fileType].toLowerCase();
  }
}
